import cn from 'classnames/bind';
import PropTypes from 'prop-types';

import s from './Quote.module.css';

const cx = cn.bind(s);

const Quote = ({
  className, color = '', text, author, size = 'small', ...attrs
}) => (
  <p className={cx('typography-quote text-center', className, {
    'tp-quotes-small': size === 'small',
    'tp-quotes': size === 'big',
  })} {...attrs}>
    <span className={cx(color, 'typography-quote__text')}>“{text}”</span>
    <span className={cx(color, 'typography-quote__author block mt-[19px]', {
      'tp-quotes-signature-small': size === 'small',
      'tp-quotes-signature': size === 'big',
    }) }>{author}</span>
  </p>
);

Quote.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  text: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'big']),
};

export default Quote;
